/**
 * Full-width dashed "add asset" trigger that sits below a mobile test card group.
 *
 * Width matches .mobile-test-card (100% of parent, max-width 26rem standalone;
 * the session context strips max-width via .session-mobile-collapsible-groups).
 *
 * Props:
 *   groupLabel — appended after "Add asset to " (e.g. "DB.1"). Omit to hide the suffix.
 *   onClick    — click handler
 *   disabled   — disables interaction
 *   className  — extra classes on the root button
 */
export default function AddAssetButton({
  groupLabel = '',
  onClick,
  disabled = false,
  className = '',
  ...props
}) {
  const label = groupLabel ? `+ Add asset to ${groupLabel}` : '+ Add asset';
  const classes = ['add-asset-btn', className].filter(Boolean).join(' ');

  return (
    <button
      type="button"
      className={classes}
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      {...props}
    >
      {label}
    </button>
  );
}
